import styled, { css } from 'styled-components';
import { colors, fontFamily } from 'components/styles/_variables';
import { Link as ReactLink } from 'react-router-dom';
import { respondTo } from '../../../styles/_respondTo';

export const Wrapper = styled.li`
  //padding: 0 20px;
  //margin-top: 30px;
  //padding-bottom: 30px;
`;

export const Title = styled.h3`
  margin: 0;
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #636262;
  padding: 0 20px;
`;

export const EditButton = styled.div`
  background-color: #00ccbc;
`;

export const EditButtonWrapper = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  padding-right: inherit;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  height: 24px;
`;

export const Description = styled.p`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #636262;
  padding: 0 20px;
`;

export const CreateLink = styled(ReactLink)`
  margin-top: ${({ mt = 20 }) => mt}px;
  display: flex;
  justify-content: flex-end;
  font-family: ${fontFamily.primary};
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: right;
  color: ${colors.elements.primary};
  padding: ${({ padding = '0 20px' }) => padding};
  cursor: pointer;
  &:hover {
    color: ${colors.elements.primary};
  }
  ${respondTo.mobile`
      margin-top: ${({ mobileMt = 20 }) => mobileMt}px;
  `}
`;

export const ItemsWrapper = styled.div`
  margin-top: 20px;
`;

export const Item = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  font-family: ${fontFamily.primary};
  margin-bottom: ${({ isProfile }) => (isProfile ? 0 : '20px')};
  padding: 0 20px;
  // cursor: ${({ isDragDisabled }) => (!isDragDisabled ? 'pointer' : '')};
  cursor: default;
`;

export const ItemTitle = styled.span`
  max-width: 72%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  z-index: 7;
  transition: 0.3s;
  color: ${({ active }) => (active ? '#ffffff' : '#636262')};
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  justify-content: ${({ justify = 'space-between' }) => justify};
  padding-left: 20px;
  align-items: center;
  margin-top: ${({ mt }) => mt}px;
`;

export const ItemButton = styled.div`
  position: relative;
  border-radius: 8px;
  background-color: #ff7828;
  width: ${({ w = 53 }) => w}px;
  height: 20px;
  font-family: ${fontFamily.primary};
  font-size: 10px;
  font-weight: bold;
  letter-spacing: -0.17px;
  //text-align: center;
  color: #ffffff;
  padding-right: ${({ pr = 6 }) => pr}px;
  margin-right: 10px;
  line-height: 20px;
  transition: 0.3s;
  text-align: ${({ textAlign = 'right' }) => textAlign};
  cursor: pointer;
  &:hover {
    color: #ffffff;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      width: 100%;
      border-radius: 0;
      z-index: 6;
    `}
  //
  ${({ isProfile, isActive }) =>
    isProfile &&
    !isActive &&
    css`
      padding-right: 10px;
      //   text-align: center;
    `}
  //
  ${({ loading }) =>
    loading &&
    css`
      cursor: not-allowed;
      opacity: 0.7;
    `}
`;

export const ItemDeleteButton = styled.div`
  display: flex;
  padding: 0 0 0 6px;
  justify-content: center;
  align-items: center;
  height: 20px;
  margin-left: 6px;
  cursor: pointer;
`;

export const ItemImg = styled.img``;

export const Divider = styled.div`
  height: 0.5px;
  margin: 20px;
  background-color: ${({ bg }) => (bg ? '#FF7828' : 'transparent')};
  opacity: 0.3;
`;
